import { useContext } from 'react';
import OrganizerContext from 'business/organizer/common/context/organizer/OrganizerContext';

const useOrganizer = (): IOrganizerContext => {
  return useContext(OrganizerContext) as IOrganizerContext;
};

export default useOrganizer;
